import Vue from 'vue'
import Vuex from 'vuex'

import auth from "./auth"
import alert from "./alert"
import database from "./database"
import users from "./users";

Vue.use(Vuex);

export default new Vuex.Store({
    strict: process.env.NODE_ENV !== "production",

    state: {
        error: null,
        loading: false,
        versions: ["1.0.1217", "1.0.1216", "1.0.1164", "1.0.1155", "1.0.1153", "1.0.1146", "1.0.1131", "1.0.1119", "1.0.1101", "1.0.1097", "1.0.1092", "1.0.989", "1.0.879", "1.0.886"],
        platforms: ['Android', 'iOS', 'Steam']
    },
    mutations: {
        setError(state, error) {
            state.error = error;
        },
        setLoading(state, loading) {
            state.loading = loading;
        },
        setVersions(state, values) {
            state.versions = values;
        },
    },
    actions: {
        init({dispatch /*, commit*/}) {
            // dispatch('database/load').then(() => {
            //     console.log("config was loaded")
            // });
            console.log("Vuex.Store init")
        }
    },
    getters: {
        versions: state => {
            return state.versions;
        },
        platforms: state => {
            return state.platforms;
        },
    },
    modules: {
        auth, alert, database, users
    }
});